// test commit
import { useState ,useEffect, lazy, Suspense } from "react"
import "./App.css"
import PopUpCenter from "@components/PopUpCenter"
import { Route, Routes } from "react-router"
import { Toaster } from "react-hot-toast"
import { useDispatch, useSelector } from "react-redux"
import { setRetrieveTokenSucess } from "@redux/slices/authenticationSlice"
import useIndexedDB from "@hooks/useIndexedDB"
import ProtectedRoute from "@components/PrivateRoute/ProtectedRoute"

import LoginPage from "@containers/LoginPage/LoginPage"
import SignUpPage from "@containers/SignUpPage/SignUpPage"
import AuthHomePage from "@containers/AuthHomePage/AuthHomePage"
import ReportsPage from "@containers/ReportsPage/ReportsPage"
import { OrbswayLoaderComponent } from "@components/OrbswayLoader/OrbswayLoaderComponent"
import ProtectAuthPage from "@components/ProtectAuthPage/ProtectAuthPage"
const ReportConcernPage = lazy(
    () => import("@containers/ReportConcernPage/ReportConcernPage")
)
// Lazy load components
const NonVRDashboardPage = lazy(
    () => import("@containers/NonVRDashboardPage/NonVRDashboardPage")
)
const ChooseViewPage = lazy(
    () => import("@containers/ChooseViewPage/ChooseViewPage")
)
const ExerciseListingPage = lazy(
    () => import("@containers/ExerciseListingPage/ExerciseListingPage")
)
const PlayExercisePage = lazy(
    () => import("@containers/PlayExercisePage/PlayExercisePage")
)
const SubscriptionPage = lazy(
    () => import("@containers/SubscriptionPage/SubscriptionPage")
)
const FaqPage = lazy(() => import("@containers/FaqPage/FaqPage"))
const MyAccountPage = lazy(
    () => import("@containers/MyAccountPage/MyAccountPage")
)
const CheckoutPage = lazy(() => import("@containers/CheckoutPage/CheckoutPage"))
const PageNotFound = lazy(
    () => import("@containers/PageNotFoundPage/PageNotFoundPage")
)
const ForgotPasswordPage = lazy(
    () => import("@containers/ForgotPassword/ForgotPasswordPage")
)
const AppointmentPage = lazy(
    () => import("@containers/AppointmentPage/AppointmentPage")
)
const ErrorBoundary = lazy(
    () => import("@components/ErrorBoundary/ErrorBoundary")
)

const ContactPage = lazy(() => import("@containers/ContactPage/ContactPage"))

function App() {
    const dispatch = useDispatch()
    const componentToShow = useSelector((state) => state.popup.component)
    const popUpCenterState = useSelector((state) => state.popup.isOpen)
    const { retrieveToken } = useIndexedDB()
    const [isTokenChecked, setIsTokenChecked] = useState(false)


    const handleRetrieveToken = async () => {
        const token = await retrieveToken()
        if (token) {
            dispatch(setRetrieveTokenSucess(token))
        }
        setIsTokenChecked(true)
    }

    useEffect(() => {
        handleRetrieveToken()
    }, [])

    if (!isTokenChecked) {
        return (
            <div className="flex items-center justify-center h-screen w-full">
                <OrbswayLoaderComponent />
            </div>
        )
    }

    return (
        <>
            <ErrorBoundary>
                <PopUpCenter
                    ContentComp={componentToShow}
                    isOpen={popUpCenterState}
                />
                <Suspense
                    fallback={
                        <div className="flex items-center justify-center h-screen w-full">
                            <OrbswayLoaderComponent />
                        </div>
                    }
                >
                    <Routes>
                        <Route
                            path="/"
                            element={
                                <ProtectAuthPage>
                                    <AuthHomePage />
                                </ProtectAuthPage>
                            }
                        />
                        <Route
                            path="/sign-in"
                            element={
                                <ProtectAuthPage>
                                    <LoginPage />
                                </ProtectAuthPage>
                            }
                        />
                        <Route
                            path="/sign-up"
                            element={
                                <ProtectAuthPage>
                                    <SignUpPage />
                                </ProtectAuthPage>
                            }
                        />
                        <Route
                            path="/forgot-password"
                            element={
                                <ProtectAuthPage>
                                    <ForgotPasswordPage />
                                </ProtectAuthPage>
                            }
                        />
                        <Route path="*" element={<PageNotFound />} />
                        <Route
                            path="/report/:gameDetails"
                            element={
                                <ProtectedRoute>
                                    <ReportsPage />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path="/non-vr-dashboard"
                            element={
                                <ProtectedRoute>
                                    <NonVRDashboardPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/chooseview"
                            element={
                                <ProtectedRoute>
                                    <ChooseViewPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/exercises/:exerciseType"
                            element={
                                <ProtectedRoute>
                                    <ExerciseListingPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/play-exercise/:gameDetails"
                            element={
                                <ProtectedRoute>
                                    <PlayExercisePage />
                                </ProtectedRoute>
                            }
                        />
                        {/* <Route
                            path="/subscribe"
                            element={<SubscriptionPage />}
                        /> */}
                        <Route
                            path="/faq"
                            element={
                                <ProtectedRoute>
                                    <FaqPage />
                                </ProtectedRoute>
                            }
                        />
                        {/* <Route
                            path="/subscribe/checkout"
                            element={
                                <ProtectedRoute>
                                    <CheckoutPage />
                                </ProtectedRoute>
                            }
                        /> */}
                        <Route
                            path="/account"
                            element={
                                <ProtectedRoute>
                                    <MyAccountPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/contact"
                            element={
                                <ProtectedRoute>
                                    <ContactPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/reportconcern"
                            element={
                                <ProtectedRoute>
                                    <ReportConcernPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/appointment"
                            element={<AppointmentPage />}
                        />
                    </Routes>
                </Suspense>
                <Toaster />
            </ErrorBoundary>
        </>
    )
}

export default App
